import { wizardTranslations } from '../components/quote-wizard/quote-wizard.i18n';

export type Language = 'fr' | 'en';

export const translations = {
  fr: {
    nav: {
      installation: 'Installation',
      boutique: 'Boutique',
      apropos: 'À propos',
      portfolio: 'Portfolio',
    },
    header: {
      devis: 'Devis',
      connexion: 'Connexion',
      deconnexion: 'Déconnexion',
    },
    hero: {
      title: 'Demandez un devis gratuit',
      subtitle: "Experts certifiés dans l'installation de systèmes photovoltaïques agréés STEG",
      cta: 'Demandez votre devis gratuit',
    },
    hero_devis: {
      title: 'Demandez un devis gratuit',
      subtitle: "Experts certifiés dans l'installation de systèmes photovoltaïques agréés STEG",
    },
    hero_realisation: {
      title: 'Projets photovoltaïques Tunisie',
      subtitle: 'Nos réalisations | Noya Énergie',
      cta: 'Demandez votre devis gratuit',
    },
    advantage: {
      subtitle: 'POURQUOI NOUS CHOISIR ?',
      title1: 'Les avantages de ',
      title2: 'Notre Entreprise',
      items: [
        {
          icon: 'check-icon.png',
          title: 'Garantie 30 ans',
          description: "Nous offrons une garantie complète de 30 ans sur tous nos produits et services pour votre tranquillité d'esprit.",
        },
        {
          icon: 'stat-icon.png',
          title: 'Matériaux de qualité-prix',
          description: "Des matériaux premium sélectionnés pour leur durabilité et leur excellent rapport qualité-prix.",
        },
        {
          icon: 'lampe-icon.png',
          title: 'Investissement intelligent',
          description: "Un investissement rentable qui valorise votre patrimoine sur le long terme avec des économies d'énergie.",
        },
        {
          icon: 'eclair-icon.png',
          title: 'Service fiable et durable',
          description: "Une équipe d'experts à votre écoute pour un service de qualité et un accompagnement personnalisé.",
        },
      ],
    },
    installation: {
      subtitle: 'COMMENT ÇA FONCTIONNE ?',
      title1: 'Notre installation ',
      title2: 'en détails',
      steps: [
        {
          image: 'step1.png',
          stepNumber: 'Étape 01',
          title: 'Visite & étude du dossier',
          description: 'Nos experts se déplacent chez vous pour envisager votre dossier pour préparer la solution solaire la plus adaptée.',
        },
        {
          image: 'step2.png',
          stepNumber: 'Étape 02',
          title: 'Mise en place',
          description: 'Nous mettons en place votre système solaire avec précision et sécurité pour un fonctionnement optimal dès le premier jour.',
        },
        {
          image: 'step3.png',
          stepNumber: 'Étape 03',
          title: 'Suivi & optimisation',
          description: 'Nous assurons un suivi des résultats pour garantir performance, économies et durabilité de votre installation.',
        },
      ],
    },
    blog: {
      projects_subtitle: 'NOS PROJETS',
      projects_title: 'Nos projets énergétiques',
      projects_btn: 'Voir nos réalisations',
      blog_subtitle: 'NOS PROJETS',
      blog_title1: 'Blog : Articles et conseils',
      blog_title2: 'pratiques',
      blog_btn: 'Tous nos articles',
      projects: [
        { id: 1, image: 'project-maison.webp', label: 'Domestique', title: 'Installation solaire pour maison individuelle', link: '#' },
        { id: 2, image: 'project-commercial.webp', label: 'Commercial', title: 'Système photovoltaïque pour local commercial', link: '#' },
        { id: 3, image: 'project-agricole.webp', label: 'Agricole', title: 'Énergie solaire pour exploitation agricole', link: '#' },
        { id: 4, image: 'project4.png', label: 'Méga Projet', title: 'Centrale solaire à grande échelle', link: '#' },
      ],
      posts: [
        {
          image: 'blog1.png',
          title: 'Vidéo découverte',
          category: 'INNOVATION',
          date: '15/03/2024',
          description: 'Investissez dans un avenir plus vert, avec nous nos panneaux solaires à prix imbattable.',
          likes: 71,
          comments: 1,
          link: '#',
        },
        {
          image: 'blog2.png',
          title: 'Noya Energie Vlog',
          category: 'INNOVATION • Astuces, Trucs',
          date: '10/04/2024',
          description: 'Parcourez toutes les performances, comment en profitez loi et garantie longue durée.',
          likes: 39,
          comments: 3,
          link: '#',
        },
        {
          image: 'blog3.png',
          title: 'STAND ELEK ENEB, foir le Kram Tunisie',
          category: 'INNOVATION',
          date: '18/04/2018 Octobre 2025',
          description: "Un moment d'échange de de visite autour de l'énergie solaire et des projets durables.",
          likes: 89,
          comments: 5,
          link: '#',
        },
      ],
    },
    contact: {
      subtitle: 'CONTACTEZ-NOUS',
      title: 'Nous répondons à toutes',
      title2: 'vos ',
      title_highlight: 'questions',
      form_title: 'Contactez - Nous',
      placeholder_name: 'Nom',
      placeholder_email: 'E-mail',
      placeholder_subject: 'Sujet',
      placeholder_message: 'Message',
      send: 'Envoyer un message',
      sending: 'Envoi en cours...',
      toast_error_title: 'Erreur',
      toast_error_desc: 'Veuillez remplir tous les champs',
      toast_success_title: 'Message envoyé !',
      toast_success_desc: 'Votre message a été envoyé avec succès. Nous vous répondrons bientôt.',
      toast_send_error_title: "Erreur d'envoi",
      toast_send_error_desc: "Une erreur est survenue lors de l'envoi du message. Veuillez réessayer.",
      infos: [
        {
          icon: 'office-icon.png',
          title: "Bureau de l'entreprise",
          lines: ['42 Rue Ibn Hilal, Menzel 5, Tunis'],
        },
        {
          icon: 'phone-icon.png',
          title: 'Numéro de téléphone',
          lines: ['Bureau: +216 26 740 224', 'Service: +216 25 178 080'],
        },
        {
          icon: 'email-icon.png',
          title: 'Adresse e-mail',
          lines: ['Envoyez nous une demande', 'noyaenergie@gmail.com'],
        },
        {
          icon: 'clock-icon.png',
          title: 'Heures de travail',
          lines: ['Lundi - Vendredi: 8h00 - 17h00', 'Samedi: 9h00 - 14h00'],
        },
      ],
    },
    quote: {
      title1: "Soleil aujourd'hui, ",
      title2: 'économies demain',
      success_title: 'Demande envoyée avec succès !',
      success_msg: 'Merci pour votre confiance. Nous avons bien reçu votre demande de devis.',
      success_detail: 'Notre équipe vous contactera dans un délai de 48 heures. Veuillez patienter et nous vous répondrons très prochainement.',
      label_name: "Nom d'utilisateur",
      label_phone: 'Téléphone',
      label_email: 'Adresse e-mail',
      label_city: 'Ville / région',
      placeholder_name: 'Entrez votre nom',
      placeholder_phone: 'Entrez votre téléphone',
      placeholder_email: 'Entrez votre adresse e-mail',
      placeholder_city: 'Entrez votre ville / région',
      error_name: 'Le nom est requis.',
      error_phone: 'Numéro de téléphone invalide.',
      error_email: 'Adresse e-mail invalide.',
      error_city: 'La ville est requise.',
      building_type_label: 'Type de bâtiment',
      building_house: 'Maison individuelle',
      building_apartment: 'Immeuble collectif',
      building_commercial: 'Local commercial',
      building_industrial: 'Ferme ou site industriel',
      area_label: 'Surface disponible pour les panneaux',
      area_under20: 'Moins de 20 m²',
      area_between20_50: '20 - 50 m²',
      area_over50: 'Plus de 50 m²',
      area_other: 'Autre',
      need_label: 'Besoin principal',
      need_reduce: 'Réduire ma facture',
      need_independence: 'Rendre ma maison autonome',
      need_other: 'Autre',
      roof_label: 'Type de toiture',
      roof_flat: 'Terrasse (Toit plat)',
      roof_inclined: 'Toit incliné',
      roof_metal: 'Toit en tôle',
      roof_other: 'Autre',
      submit: 'Demander un devis gratuit',
      submitting: 'Envoi en cours...',
      electricity_label: "Facture d'électricité moyenne (DT/mois)",
      electricity_hint: '➜ pour aider à estimer la taille du système 3K / 6K / 10K',
      toast_success: 'Demande envoyée !',
      toast_success_desc: 'Nous vous contacterons dans un délai de 48 heures.',
    },
    footer: {
      desc1: 'Nous sommes une entreprise solaire fiable et expérimentée,',
      desc2: 'offrant des solutions énergétiques durables et abordables,',
      desc3: 'personnalisées pour répondre à vos besoins spécifiques.',
      nav_title: 'Navigation',
      services_title: 'Nos services',
      copyright: 'All right policy reserved',
      nav_links: [
        { label: 'Accueil', url: '#' },
        { label: 'Boutique', url: '#' },
        { label: 'A propos', url: '#' },
        { label: 'Portfolio', url: '#' },
        { label: 'Contact', url: '#' },
      ],
      service_links: [
        { label: 'Mise en place de systèmes solaires', url: '#' },
        { label: 'Fourniture des équipements', url: '#' },
        { label: 'Installation de panneaux solaires', url: '#' },
        { label: 'Audit et optimisation énergétique', url: '#' },
        { label: 'Exploitation et maintenance', url: '#' },
      ],
    },
    partners: {
      title: 'Nous travaillons avec des clients, des marques et des startups',
    },
    wizard: wizardTranslations.fr,
  },

  en: {
    nav: {
      installation: 'Installation',
      boutique: 'Shop',
      apropos: 'About',
      portfolio: 'Portfolio',
    },
    header: {
      devis: 'Quote',
      connexion: 'Login',
      deconnexion: 'Logout',
    },
    hero: {
      title: 'Request a free quote',
      subtitle: 'STEG-certified experts in the installation of photovoltaic systems',
      cta: 'Request your free quote',
    },
    hero_devis: {
      title: 'Request a free quote',
      subtitle: 'STEG-certified experts in the installation of photovoltaic systems',
    },
    hero_realisation: {
      title: 'Photovoltaic Projects Tunisia',
      subtitle: 'Our achievements | Noya Energy',
      cta: 'Request your free quote',
    },
    advantage: {
      subtitle: 'WHY CHOOSE US?',
      title1: 'The advantages of ',
      title2: 'Our Company',
      items: [
        {
          icon: 'check-icon.png',
          title: '30-Year Warranty',
          description: 'We offer a full 30-year warranty on all our products and services for your peace of mind.',
        },
        {
          icon: 'stat-icon.png',
          title: 'Quality-Price Materials',
          description: 'Premium materials selected for their durability and excellent value for money.',
        },
        {
          icon: 'lampe-icon.png',
          title: 'Smart Investment',
          description: 'A profitable investment that increases the value of your assets over the long term with energy savings.',
        },
        {
          icon: 'eclair-icon.png',
          title: 'Reliable & Durable Service',
          description: 'A team of experts at your service for quality service and personalized support.',
        },
      ],
    },
    installation: {
      subtitle: 'HOW DOES IT WORK?',
      title1: 'Our installation ',
      title2: 'in detail',
      steps: [
        {
          image: 'step1.png',
          stepNumber: 'Step 01',
          title: 'Site visit & file review',
          description: 'Our experts visit you to review your file and prepare the most suitable solar solution.',
        },
        {
          image: 'step2.png',
          stepNumber: 'Step 02',
          title: 'Setup',
          description: 'We set up your solar system with precision and safety for optimal operation from day one.',
        },
        {
          image: 'step3.png',
          stepNumber: 'Step 03',
          title: 'Monitoring & optimization',
          description: 'We monitor the results to ensure performance, savings and durability of your installation.',
        },
      ],
    },
    blog: {
      projects_subtitle: 'OUR PROJECTS',
      projects_title: 'Our energy projects',
      projects_btn: 'See our achievements',
      blog_subtitle: 'OUR BLOG',
      blog_title1: 'Blog: Articles and practical',
      blog_title2: 'tips',
      blog_btn: 'All our articles',
      projects: [
        { id: 1, image: 'project-maison.webp', label: 'Domestic', title: 'Solar installation for individual home', link: '#' },
        { id: 2, image: 'project-commercial.webp', label: 'Commercial', title: 'Photovoltaic system for commercial premises', link: '#' },
        { id: 3, image: 'project-agricole.webp', label: 'Agricultural', title: 'Solar energy for agricultural farm', link: '#' },
        { id: 4, image: 'project4.png', label: 'Mega Project', title: 'Large-scale solar power plant', link: '#' },
      ],
      posts: [
        {
          image: 'blog1.png',
          title: 'Discovery Video',
          category: 'INNOVATION',
          date: '15/03/2024',
          description: 'Invest in a greener future with our solar panels at unbeatable prices.',
          likes: 71,
          comments: 1,
          link: '#',
        },
        {
          image: 'blog2.png',
          title: 'Noya Energy Vlog',
          category: 'INNOVATION • Tips & Tricks',
          date: '10/04/2024',
          description: 'Browse all performances, how to benefit from the law and long-term warranty.',
          likes: 39,
          comments: 3,
          link: '#',
        },
        {
          image: 'blog3.png',
          title: 'STAND ELEK ENEB, Kram Fair Tunisia',
          category: 'INNOVATION',
          date: '18/04/2018 October 2025',
          description: 'A moment of exchange and visit around solar energy and sustainable projects.',
          likes: 89,
          comments: 5,
          link: '#',
        },
      ],
    },
    contact: {
      subtitle: 'CONTACT US',
      title: 'We answer all',
      title2: 'your ',
      title_highlight: 'questions',
      form_title: 'Contact Us',
      placeholder_name: 'Name',
      placeholder_email: 'E-mail',
      placeholder_subject: 'Subject',
      placeholder_message: 'Message',
      send: 'Send a message',
      sending: 'Sending...',
      toast_error_title: 'Error',
      toast_error_desc: 'Please fill in all fields',
      toast_success_title: 'Message sent!',
      toast_success_desc: 'Your message has been sent successfully. We will reply soon.',
      toast_send_error_title: 'Sending error',
      toast_send_error_desc: 'An error occurred while sending the message. Please try again.',
      infos: [
        {
          icon: 'office-icon.png',
          title: 'Company office',
          lines: ['42 Rue Ibn Hilal, Menzel 5, Tunis'],
        },
        {
          icon: 'phone-icon.png',
          title: 'Phone number',
          lines: ['Office: +216 26 740 224', 'Service: +216 25 178 080'],
        },
        {
          icon: 'email-icon.png',
          title: 'Email address',
          lines: ['Send us a request', 'noyaenergie@gmail.com'],
        },
        {
          icon: 'clock-icon.png',
          title: 'Working hours',
          lines: ['Monday - Friday: 8:00 AM - 5:00 PM', 'Saturday: 9:00 AM - 2:00 PM'],
        },
      ],
    },
    quote: {
      title1: 'Sunshine today, ',
      title2: 'savings tomorrow',
      success_title: 'Request sent successfully!',
      success_msg: 'Thank you for your trust. We have received your quote request.',
      success_detail: 'Our team will contact you within 48 hours. Please wait and we will reply very soon.',
      label_name: 'Username',
      label_phone: 'Phone',
      label_email: 'Email address',
      label_city: 'City / region',
      placeholder_name: 'Enter your name',
      placeholder_phone: 'Enter your phone',
      placeholder_email: 'Enter your email address',
      placeholder_city: 'Enter your city / region',
      error_name: 'Name is required.',
      error_phone: 'Invalid phone number.',
      error_email: 'Invalid email address.',
      error_city: 'City is required.',
      building_type_label: 'Building type',
      building_house: 'Individual house',
      building_apartment: 'Apartment building',
      building_commercial: 'Commercial premises',
      building_industrial: 'Farm or industrial site',
      area_label: 'Available area for panels',
      area_under20: 'Less than 20 m²',
      area_between20_50: '20 - 50 m²',
      area_over50: 'More than 50 m²',
      area_other: 'Other',
      need_label: 'Main need',
      need_reduce: 'Reduce my bill',
      need_independence: 'Make my home self-sufficient',
      need_other: 'Other',
      roof_label: 'Roof type',
      roof_flat: 'Terrace (flat roof)',
      roof_inclined: 'Sloped roof',
      roof_metal: 'Metal sheet roof',
      roof_other: 'Other',
      submit: 'Request a free quote',
      submitting: 'Sending...',
      electricity_label: 'Average electricity bill (DT/month)',
      electricity_hint: '➜ to help estimate the system size 3K / 6K / 10K',
      toast_success: 'Request sent!',
      toast_success_desc: 'We will contact you within 48 hours.',
    },
    footer: {
      desc1: 'We are a reliable and experienced solar company,',
      desc2: 'offering sustainable and affordable energy solutions,',
      desc3: 'personalized to meet your specific needs.',
      nav_title: 'Navigation',
      services_title: 'Our services',
      copyright: 'All rights reserved',
      nav_links: [
        { label: 'Home', url: '#' },
        { label: 'Shop', url: '#' },
        { label: 'About', url: '#' },
        { label: 'Portfolio', url: '#' },
        { label: 'Contact', url: '#' },
      ],
      service_links: [
        { label: 'Solar system installation', url: '#' },
        { label: 'Equipment supply', url: '#' },
        { label: 'Solar panel installation', url: '#' },
        { label: 'Energy audit and optimization', url: '#' },
        { label: 'Operation and maintenance', url: '#' },
      ],
    },
    partners: {
      title: 'We work with clients, brands and startups',
    },
    wizard: wizardTranslations.en,
  },
};
